import { mediaUrl } from "@/lib/portalApi";
import VoicePlayer from "./VoicePlayer";

export default function MediaGrid({ media, testid }) {
  if (!media || media.length === 0) return null;
  const audio = media.filter((m) => m.type === "audio");
  const visual = media.filter((m) => m.type !== "audio");
  return (
    <div data-testid={testid}>
      {visual.length > 0 && (
        <div className={`mt-3 grid gap-2 ${visual.length === 1 ? "grid-cols-1" : "grid-cols-2"}`}>
          {visual.map((m, i) => (
            <div key={i} className="rounded-lg overflow-hidden border border-[#E0D8C9] bg-black/5">
              {m.type === "video" ? (
                <video src={mediaUrl(m.path)} controls className="w-full max-h-96 bg-black" />
              ) : (
                <img src={mediaUrl(m.path)} alt="shared" className="w-full max-h-96 object-cover" />
              )}
            </div>
          ))}
        </div>
      )}
      {audio.map((m, i) => (
        <div key={`a${i}`} className="mt-3"><VoicePlayer path={m.path} /></div>
      ))}
    </div>
  );
}
